/*eslint-disable*/
import React from "react";
import {
  useTable,
  useFilters,
  useAsyncDebounce,
  useSortBy,
  usePagination,
} from "react-table";
import classnames from "classnames";
// A great library for fuzzy filtering/sorting items
import matchSorter from "match-sorter";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";

// reactstrap components
import { Container, Row, Col, FormGroup, Input,Button } from "reactstrap";

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <div className="w-100 " >
    <FormGroup >
      <Input 
        placeholder={`Search ${count} records...`}
        type="text"
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
      />
    </FormGroup></div>
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Our table component
function Table({ columns, data,calldata,isnext,hidecolumnsdata,countforcall ,ageOutside,counts=0}) {
  const [numberOfRows, setNumberOfRows] = React.useState({
    value: 10,
    label: "10 rows",
  });
  const [pageSelect, handlePageSelect] = React.useState({
    value: 0,
    label: "1",
  });
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );
const hidecolumns=(value)=>{
  hidecolumnsdata.map((head)=>{
    toggleHideColumn(head,value);
  })
}
  const defaultColumn = React.useMemo(
    () => ({
      
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    visibleColumns,
    nextPage,
    pageOptions,
    pageCount,
    previousPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    gotoPage,
    setFilter,
    toggleHideColumn
  } = useTable(
    {
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
      initialState: { pageSize: 10, pageIndex: 0 },
    },
    useFilters, // useFilters!
    useSortBy,
    usePagination
  );
  React.useEffect(() => {
      hidecolumns(true);  
 },[columns]);
 React.useEffect(() => {
  // This will now use our custom filter for age
  setFilter("city", ageOutside);
}, [ageOutside]);
async function callapitimes(value) {
  if(value.value>page.length&&value.value>page.length){
    var count= Number(value.value/page.length).toFixed();
    countforcall(count);
   
}

}
  // We don't want to render all of the rows for this example, so cap
  // it for this use case
  // const firstPageRows = rows.slice(0, 10);
  let pageSelectData = Array.apply(
    null,
    Array(pageOptions.length)
  ).map(function () {});
  let numberOfRowsData = [5, 10, 20,  50, 100];

  return (
    <>
      <div className="ReactTable -striped -highlight primary-pagination">
        <div className="pagination-top">
          <div className="-pagination">
            <div className="-previous">
              <button
                type="button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="-btn"
              >
                Previous
              </button>
            </div>
            <div className="-center">
              <Container>
                <Row className="justify-content-center">
                  <Col md="6" sm="6" xs="12">
                    <Row>
                    <Col md="6" className="p-0">
                    <span style={{display:'inline'}}><h6 style={{marginTop:'15px',marginLeft:'20%'}}>  Page :</h6></span></Col>
                    <Col md="6" className="p-0">
                    <Select 
                      className="react-select primary"
                      classNamePrefix="react-select"
                      name="pageSelect"
                      value={pageSelect}
                      onChange={(value) => {
                        gotoPage(value.value);
                        handlePageSelect(value);
                      }}
                      options={pageSelectData.map((prop, key) => {
                        return {
                          value: key,
                          label:(key + 1),
                        };
                      })}
                      placeholder="Choose Page"
                    />   </Col>
                    </Row>
                  </Col>
                  <Col md="5"  xs="12">
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      name="numberOfRows"
                      value={numberOfRows}
                      onChange={(value) => {
                        setPageSize(value.value);
                        setNumberOfRows(value);
                        callapitimes(value);
                      }}
                      options={numberOfRowsData.map((prop) => {
                        return {
                          value: prop,
                          label: prop + " rows",
                        };
                      })}
                      placeholder="Choose Rows"
                    />
                  </Col>
              
                </Row>
              </Container>
            </div>
            <div className="-next">
              <button
                type="button"
                onClick={() => {
                  if(isnext){
                  calldata()}
                  nextPage()

                }}
                className="-btn"

              >
                Next
              </button>
            </div>
          </div>
          <div className='w-100'>
          <Button onClick={()=>{
                   hidecolumns(false);
                   document.getElementsByTagName("tbody")[0].style.width = "350%";

                   document.getElementsByTagName("thead")[0].style.width = "350%";

                  //  document.getElementsByTagName("th")[0].style.width = "200px";
                  //  document.getElementsByTagName("td")[0].style.width = "200px";


                  }}>more</Button>
                   <Button onClick={()=>{
                   hidecolumns(true);
                   document.getElementsByTagName("tbody")[0].style.width = "100%";
                   document.getElementsByTagName("thead")[0].style.width = "100%";

                   

                  }}>less</Button>
                  </div>
        </div>
        <table {...getTableProps()} className="rt-table">
          <thead className="rt-thead -header">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr ">
                {headerGroup.headers.map((column, key) => (
                  <th 
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={classnames("rt-th rt-resizable-header row  m-1 p-1", {
                      "-cursor-pointer ": headerGroup.headers.length - 1 !== key,
                      "-sort-asc": column.isSorted && !column.isSortedDesc,
                      "-sort-desc": column.isSorted && column.isSortedDesc,
                    })}
                  >
                    <div className="rt-resizable-header-content  m-0 p-0 col-12 d-flex align-items-start"  style={{ textAlignLastL:'right', overflowWrap:'break-word',whiteSpace: 'pre-wrap',wordWrap:'break-word'}}  >
                      {column.render("Header")}
                    </div>
                    {/* Render the columns filter UI */}
                    <div className="col-12 d-flex  m-0 p-0 align-items-end">
                      {headerGroup.headers.length - 1 === key
                        ? null
                        : column.canFilter
                        ? column.render("Filter")
                        : null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="rt-tbody"  >
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr  style={{width:'100%'}}
                  {...row.getRowProps()}
                  className={classnames(
                    "rt-tr",
                    { " -odd": i % 2 === 0 },
                    { " -even": i % 2 === 1 }
                  )}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td  className="rt-td " {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          {counts!==0? <tfoot style={{borderTop:'1px solid #dee2e6'}}>
           <div style={{display:'initial',float: 'right',}} className=' p-2 my-2 mr-3'> {data.length} of {counts} Records</div>
          </tfoot>:null}
        </table>
        <div className="pagination-bottom"></div>
      </div>
    </>
  );
}

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = (val) => typeof val !== "number";

export default Table;

                  
                     